import { ChangeDetectorRef, Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewEncapsulation } from "@angular/core";
import { CommonService } from "app/reusable/common.service";
import { IntakeHelpPlansModel } from 'app/_models/intake-help-plans.model';
import { HelpPlanTypeModel } from 'app/_models/help-plan-type.model';
import { environment } from "environments/environment";
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { CedNotificationService } from "ced-ng-library";

@Component({
  selector: "app-help-plans-types-list",
  templateUrl: "./help-plans-types-list.component.html",
  styleUrls: ["./help-plans-types-list.component.scss"],
  encapsulation: ViewEncapsulation.Emulated,
})
export class HelpPlansTypesListComponent implements OnInit, OnDestroy {
  intakePlanData: { intake: IntakeHelpPlansModel; isSelected: boolean }[] = [];
  helpPlanTypeData: { dossier: HelpPlanTypeModel; isSelected: boolean }[] = [];
  @Input() intakePlanChecked: IntakeHelpPlansModel[] = [];
  @Input() helpPlanTypeChecked: HelpPlanTypeModel[] = [];
  @Output() intakePlansChanged: EventEmitter<IntakeHelpPlansModel[]> = new EventEmitter();
  @Output() helpPlanTypeChanged: EventEmitter<HelpPlanTypeModel[]> = new EventEmitter();
  public AlphaURL : string = environment.Services.AlphaURLSlot2;
  
  private _subject$: Subject<boolean> = new Subject();
  codeList = ["AAN", "POL", "OPN", "AFV"];

  constructor(private CommonService: CommonService, private cd : ChangeDetectorRef, private cedNotificationService: CedNotificationService) {}

  ngOnInit() {
    this.getIntakePlans(); 
    this.getHelpPlanType();
  }

  getIntakePlans(): void {
    let getHelpPlansUrl = `HelpPlan/GetIntakeHelpPlans`;
    this.CommonService.getData(getHelpPlansUrl, this.AlphaURL)
      .pipe(takeUntil(this._subject$))
      .subscribe((data: any[]) => {
        data.forEach((item) => {

          this.intakePlanData = [...this.intakePlanData, {
            intake: item,
            isSelected: this.intakePlanChecked.some(
              (el) => el.hplId == item.hplId
            ),
          }]; 
        }); 
      },
      (error) => {
        this.cedNotificationService.warning("NOTIFICATIONS.GET_DATA");
      });
  }

  getHelpPlanType(): void {
    let GetHelpPlansTypesUrl: string = `HelpPlanType/GetAll`;
    this.CommonService.getData(GetHelpPlansTypesUrl,this.AlphaURL)
      .pipe(takeUntil(this._subject$))
      .subscribe((data: any[]) => {
        data.forEach((item) => {
          this.helpPlanTypeData = [
            ...this.helpPlanTypeData,
            {
              dossier: item,
              isSelected: this.helpPlanTypeChecked.some(
                (el) => el.htyId == item.htyId
              ),
            },
          ]; 
        }); 
      },
      (error) => {
        this.cedNotificationService.warning("NOTIFICATIONS.GET_HELP_PLAN");
      });
  }

  intakeChange(item: {
    intake: IntakeHelpPlansModel;
    isSelected: boolean;
  }): void {
    if (this.codeList.includes(item.intake.hplCode.trim())) {
      this.intakePlanData = this.intakePlanData.map((e) => {
        if (this.codeList.includes(e.intake.hplCode.trim())) {
          e.isSelected = item.isSelected;
        }
        return e;
      });
    }
    this.intakePlanChecked = this.intakePlanData
      .filter((r) => r.isSelected == true)
      .map((e) => e.intake);
    this.intakePlansChanged.emit(this.intakePlanChecked);
  }

  dossierChange(item: {
    dossier: HelpPlanTypeModel;
    isSelected: boolean;
  }): void {
    this.helpPlanTypeChecked = this.helpPlanTypeData
      .filter((r) => r.isSelected == true)
      .map((e) => e.dossier);
    this.helpPlanTypeChanged.emit(this.helpPlanTypeChecked);
  }


  trackByFn(index: number, item: any): string {
    return item.intake.hplCode;
  }

  ngOnDestroy() {
    this._subject$.unsubscribe();
  }
}
